import React from 'react';
import { Feed, Icon, Image } from 'semantic-ui-react';

import { PersonaLink } from '../../Links';
import { formatDatetime, getUserAvatar } from '../../Utils';

interface PersonaProps {
  gender: 'M' | 'F';
  id: string;
  lastVisit: string;
  nickname?: string;
  numPosts: number;
  subscriptionCount: number;
}

const Persona = ({
  gender,
  id,
  lastVisit,
  nickname,
  numPosts,
  subscriptionCount,
}: PersonaProps) => (
  <Feed.Event>
    <Feed.Label>
      <Image src={getUserAvatar(id)} />
    </Feed.Label>
    <Feed.Content>
      <Feed.Summary>
        <Feed.User>
          <PersonaLink id={id}>
            {id}
            {' '}
            (
            {nickname || '沒有綽號喔'}
            )
          </PersonaLink>
        </Feed.User>
        <Feed.Date>
          上次留下足跡
          {' '}
          {formatDatetime(lastVisit)}
        </Feed.Date>
      </Feed.Summary>
      <Feed.Meta>
        <Feed.Like>
          {
            gender === 'M' ? (
              <Icon name="male" color="blue" />
            ) : (
              <Icon name="female" color="pink" />
            )
          }
        </Feed.Like>
        <Feed.Like>
          <Icon name="comment alternate outline" color="orange" />
          {numPosts}
        </Feed.Like>
        <Feed.Like>
          <Icon name="favorite" color="yellow" />
          {subscriptionCount}
        </Feed.Like>
      </Feed.Meta>
    </Feed.Content>
  </Feed.Event>
);

interface PersonaData extends PersonaProps {
  last_visit: string;
  num_posts: number;
  subscription_count: number;
}

export default ({ data }: { data: PersonaData[] }) => (
  data.length > 0 ? (
    <Feed size="large">
      {data.map((persona) => (
        <Persona
          gender={persona.gender}
          id={persona.id}
          key={persona.id}
          lastVisit={persona.last_visit}
          nickname={persona.nickname}
          numPosts={persona.num_posts}
          subscriptionCount={persona.subscription_count}
        />
      ))}
    </Feed>
  ) : null
);
